import request from '@/utils/request'

// 创建银行卡
export const addBank = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/bank',
    method: 'post',
    data
})

// 删除银行卡
export const delBank = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/bank/' + data.id,
    method: 'delete',
    data
})

// 编辑银行卡
export const setBank = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/bank/' + data.id,
    method: 'patch',
    data
})

// 获取银行卡列表
export const getBankList = (params: any) => request({
    url: '/manage/merchant/' + params + '/bank',
    method: 'get'
})

// 获取银行卡详情
export const getBankInfo = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/bank/' + params.id,
    method: 'get'
})